import React, { useState } from 'react';


const RestaurantForm = ({ position, address, cityName, onSave, onCancel, initialData, isEditMode }) => {
  const [formData, setFormData] = useState({
    name: initialData?.name || '',
    koreanName: initialData?.koreanName || '', // ⭐ 한글 이름 추가
    address: address || '',
    rating: 5,
    memo: initialData?.memo || '',
    lat: position.lat,
    lng: position.lng,
  });


  const hasPrefilledName = Boolean(initialData?.name);


  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      alert('맛집 이름을 입력해주세요.');
      return;
    }


    onSave(formData);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  return (
    <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        padding: '20px',                          // ✅ 30px → 20px
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
        zIndex: 2000,
        width: 'min(400px, 90vw)',                // ✅ 핵심! 400px 또는 화면의 90% 중 작은 값
        maxHeight: '85vh',                        // ✅ 80vh → 85vh
        overflowY: 'auto',
        boxSizing: 'border-box',                  // ✅ 추가
    }}>
      <h2 style={{ marginTop: 0, color: '#333', fontSize: 'clamp(16px, 4vw, 20px)' }}> {/* ✅ 폰트 유동적 */}
        {isEditMode ? '✏️ 맛집 수정' : hasPrefilledName ? '검색된 맛집 추가' : '맛집 추가'}
      </h2>
      
      <form onSubmit={handleSubmit}>
        {/* 맛집 이름 */}
        <div style={{ marginBottom: '12px' }}>   {/* ✅ 15px → 12px */}
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold', fontSize: '14px' }}>
            맛집 이름 * {hasPrefilledName && !isEditMode && 
              <span style={{ color: '#4285f4', fontSize: '11px' }}>(검색된 장소)</span>}
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={hasPrefilledName && !isEditMode}
            placeholder={hasPrefilledName ? '' : '맛집 이름을 입력하세요'}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '14px',
              boxSizing: 'border-box',
              background: (hasPrefilledName && !isEditMode) ? '#f5f5f5' : 'white',
              color: (hasPrefilledName && !isEditMode) ? '#333' : '#000',
            }}
          />
          {hasPrefilledName && !isEditMode && (
            <p style={{ margin: '4px 0 0 0', fontSize: '11px', color: '#666', fontStyle: 'italic' }}>
              💡 검색된 장소의 이름은 수정할 수 없습니다.
            </p>
          )}
        </div>

        {/* 한글 이름 */}
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold', fontSize: '14px' }}>
            한글 이름 <span style={{ fontSize: '12px', color: '#999', fontWeight: 'normal' }}>(선택)</span>
          </label>
          <input
            type="text"
            name="koreanName"
            value={formData.koreanName}
            onChange={handleChange}
            placeholder="예: 스타벅스 강남점"
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '14px',
              boxSizing: 'border-box',
            }}
          />
        </div>

        {/* 메모 */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold', fontSize: '14px' }}>
            메모
          </label>
          <textarea
            name="memo"
            value={formData.memo}
            onChange={handleChange}
            placeholder="메모를 입력하세요 (선택사항)"
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '14px',
              resize: 'vertical',        // ✅ 사용자가 직접 드래그로 조절 가능
              boxSizing: 'border-box',
              minHeight: '80px',         // ✅ 최소 높이
              maxHeight: '200px',        // ✅ 너무 커지면 스크롤
              overflowY: 'auto',         // ✅ maxHeight 넘으면 스크롤
              lineHeight: '1.5',
            }}
          />
        </div>

        {/* 버튼 */}
        <div style={{ display: 'flex', gap: '8px' }}>
          <button type="submit" style={{
            flex: 1, padding: '12px',
            background: isEditMode ? '#34a853' : '#4285f4',
            color: 'white', border: 'none',
            borderRadius: '8px', cursor: 'pointer',
            fontSize: '15px', fontWeight: 'bold',
          }}>
            {isEditMode ? '수정 완료' : '저장'}
          </button>
          <button type="button" onClick={onCancel} style={{
            flex: 1, padding: '12px',
            background: '#ddd', color: '#333',
            border: 'none', borderRadius: '8px',
            cursor: 'pointer', fontSize: '15px', fontWeight: 'bold',
          }}>
            취소
          </button>
        </div>
      </form>


      {/* 도시 정보 */}
      <div style={{ marginTop: '12px', padding: '8px', background: '#f5f5f5', borderRadius: '4px' }}>
        <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>📍 {cityName}</p>
        {address && (
          <p style={{ margin: '4px 0 0 0', fontSize: '11px', color: '#999' }}>{address}</p>
        )}
      </div>
    </div>
  );
};


export default RestaurantForm;
